import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

const IG = "https://www.instagram.com/svproduction6?stkn=MWZoMm5wc2lkcDk4bQ==";

export default function Footer() {
  return (
    <footer className="bg-[#050506] text-[#CDC7BA] mt-24 border-t border-[rgba(255,255,255,0.06)]">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <div className="sv-mark">SV</div>
            <div>
              <div className="font-display-cinzel text-lg text-[#F4E4BC]">SV TALENT AGENCY</div>
              <div className="font-mono-label text-[10px] text-[#C5A059] mt-1">Talent Meets Opportunity</div>
            </div>
          </div>
          <div className="sv-divider-gold my-6 max-w-xs" />
          <p className="text-sm text-[#8A8478] leading-relaxed max-w-md">
            Talent discovery, casting and representation platform connecting exceptional models,
            actors, creators and performers with opportunities across entertainment, fashion,
            advertising and digital media.
          </p>
          <div className="mt-6 space-y-2 text-sm text-[#CDC7BA]">
            <div className="flex items-center gap-3"><MapPin size={14} className="text-[#C5A059]" /> Mohali</div>
            <a href="tel:+918968681108" className="flex items-center gap-3 hover:text-[#F4E4BC] transition-colors" data-testid="footer-phone"><Phone size={14} className="text-[#C5A059]" /> 89686 81108</a>
            <a href={IG} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#F4E4BC] transition-colors" data-testid="footer-instagram"><Instagram size={14} className="text-[#C5A059]" /> Instagram <span className="text-[#8A8478]">@svproduction6</span></a>
          </div>
        </div>
        <div>
          <div className="font-mono-label text-[10px] text-[#C5A059] mb-4">Discover</div>
          <ul className="space-y-2 text-sm text-[#8A8478]">
            <li><Link to="/talent" className="hover:text-[#F4E4BC]">Talent</Link></li>
            <li><Link to="/models" className="hover:text-[#F4E4BC]">Models</Link></li>
            <li><Link to="/actors" className="hover:text-[#F4E4BC]">Actors</Link></li>
            <li><Link to="/creators" className="hover:text-[#F4E4BC]">Creators</Link></li>
            <li><Link to="/casting" className="hover:text-[#F4E4BC]">Casting</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label text-[10px] text-[#C5A059] mb-4">Company</div>
          <ul className="space-y-2 text-sm text-[#8A8478]">
            <li><Link to="/services" className="hover:text-[#F4E4BC]">Productions</Link></li>
            <li><Link to="/about" className="hover:text-[#F4E4BC]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#F4E4BC]">Contact</Link></li>
            <li><Link to="/pricing" className="hover:text-[#F4E4BC]">Membership</Link></li>
            <li><Link to="/join" className="hover:text-[#F4E4BC]">Join as Talent</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[rgba(255,255,255,0.05)]">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-[11px] font-mono-label text-[#4A4842]">
          <div>© 2026 SV TALENT AGENCY · ALL RIGHTS RESERVED</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-[#C5A059]">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#C5A059]">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
